// extracted by mini-css-extract-plugin
export var billingAddress = "_x6-g";
export var contactInfo = "_x6-d";
export var customerInfoContainer = "_x6-c";
export var customerInfoContainerMobile = "_x6-h";
export var customerInfoRow = "_x6-a";
export var customerInfoSection = "_x6-b";
export var fullWidthDividerMobile = "_x6-i";
export var imageContainer = "_x6-1";
export var paymentMethod = "_x6-e";
export var priceText = "_x6-6";
export var priceTextMobile = "_x6-7";
export var product = "_x6-0";
export var productImage = "_x6-2";
export var productInfo = "_x6-4";
export var productMobile = "_x6-9";
export var productTitle = "_x6-8";
export var quantityBadge = "_x6-3";
export var quantityText = "_x6-5";
export var shippingAddress = "_x6-f";